import React from 'react';
import { PropertyGallery } from '../components/PropertyGallery';

export const GalleryPage = () => {
  return (
    <div className="min-h-screen bg-background pt-20">
      {/* Gallery Component */}
      <PropertyGallery />
    </div>
  );
};
